import { render, staticRenderFns } from "./ButtonText.vue?vue&type=template&id=8bef3bc2"
import script from "./ButtonText.vue?vue&type=script&lang=js"
export * from "./ButtonText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports